import createAsyncThunkFromFetch from '../../store/middlewares/createAsyncThunkFromFetch';
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { Device } from './devices.types';
import {
  createCompanyDeviceAPI,
  getCompanyDevices,
  removeCompanyDevice as removeCompanyDeviceAPI,
} from './devices.api';

const name = 'devices';

export const fetchCompanyDevices = createAsyncThunkFromFetch(`${name}/fetchCompanyDevices`, getCompanyDevices);
export const createCompanyDevice = createAsyncThunkFromFetch(`${name}/addDevice`, createCompanyDeviceAPI);

export const removeCompanyDevice = createAsyncThunkFromFetch(`${name}/removeCompanyDevice`, removeCompanyDeviceAPI);

const deviceProviderAdapter = createEntityAdapter<Device>({
  selectId: device => device.id,
});

export const deviceProviderSelectors = deviceProviderAdapter.getSelectors();

const paymentProviderSlice = createSlice({
  name,
  initialState: deviceProviderAdapter.getInitialState<{
    roomDevices: Record<string, string[]>;
    companyDevices: Record<string, string[]>;
  }>({
    roomDevices: {},
    companyDevices: {},
  }),
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchCompanyDevices.fulfilled, (state, { payload, meta }) => {
        const { companyId } = meta.arg;
        deviceProviderAdapter.setAll(state, payload);
        state.companyDevices[companyId] = payload.map(p => p.id);
      })
      .addCase(createCompanyDevice.fulfilled, (state, { payload, meta }) => {
        const { companyId } = meta.arg;
        deviceProviderAdapter.upsertOne(state, payload);
        state.companyDevices[companyId] = [...state.companyDevices[companyId], payload.id];
      })
      .addCase(removeCompanyDevice.fulfilled, (state, { meta }) => {
        const { deviceId, companyId } = meta.arg;
        deviceProviderAdapter.removeOne(state, deviceId);
        state.companyDevices[companyId] = state.companyDevices[companyId].filter(d => d !== deviceId);
      });
  },
});

const { reducer } = paymentProviderSlice;

export default reducer;
